const RemoveStyle =  {
    overlay:{
        backdropFilter: 'blur(3px)',
    },
    content: {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '100%',
        width:'20em',
        backgroundColor:'rgb(211,211,211)',
        display:'flex',
        justifyContent:'center',
        paddingTop:'1em',
        paddingRight:'1em',
        direction:'rtl',
        overflowY:'hidden'
      },
};
export default RemoveStyle;
